const CartActionTypes = {
    FETCH_CART_SUCCESS: 'FETCH_CART_SUCCESS',
    FETCH_CART_FAILURE: 'FETCH_CART_FAILURE',
    ADD_ITEM: 'ADD_ITEM',
    ADD_ITEM_WITH_COUNT: 'ADD_ITEM_WITH_COUNT',
    REMOVE_ITEM: 'REMOVE_ITEM',
    CLEAR_ITEM: 'CLEAR_ITEM',
    CLEAR_CART: 'CLEAR_CART',
    SHOW_ADD_TO_CART_POPUP: 'SHOW_ADD_TO_CART_POPUP',
    HIDE_ADD_TO_CART_POPUP: 'HIDE_ADD_TO_CART_POPUP'
};

export default CartActionTypes;

